<template>
  <div class="row m-0">
    <Navigation />
    <Container>
      <Loader
        v-if="showLoader"
      />
      <div class="row m-0">
        <div class="col-sm-6 col-md-6 col-lg-4 p-1">
          <Square
            :centered="true"
            class="deepify-light-bg rounded-bottom-2"
            @click.native="isResearchNameModalVisible = true"
          >
            <div class="d-flex flex-column align-items-center text-center">
              <Square
                class="create-icon deepify-bg-success rounded-circle mb-3"
                :centered="true"
              >
                <FontAwesome
                  icon="fas fa-plus"
                  :size="18"
                />
              </Square>
              <h6>CREATE NEW PROJECT</h6>
            </div>
          </Square>
        </div>
        <div
          v-for="(research, index) in researches"
          :key="index"

          class="col-sm-6 col-md-6 col-lg-4 p-1"
        >
          <Square
            :centered="true"
            :class="getSquareClass(index, researches.length)"
            class="deepify-light-bg overflow-hidden"

            @click.native="$router.push(`/research/${research._id}/clusters`)"
          >
            <div class="text-center px-3">
              <h6 class="text-uppercase p-0 m-0">
                {{ research.campaign_name }}
              </h6>
              <small>
                <i>
                  {{
                    new Date(
                      parseInt(research._id.toString().substring(0,8), 16 ) * 1000
                    ).toLocaleDateString("tr-TR")
                  }}
                </i>
              </small>
            </div>
            <div class="position-absolute p-2 ml-1 left-0 bottom-0">
              <img
                src="https://dummyimage.com/18/17223b/17223b"
                class="rounded-circle mr-1"
                alt="User"
              >
              <img
                src="https://dummyimage.com/18/444444/444444"
                class="rounded-circle mr-1"
                alt="User"
              >
              <img
                src="https://dummyimage.com/18/6b778d/6b778d"
                class="rounded-circle mr-1"
                alt="User"
              >
            </div>
          </Square>
        </div>

        <ResearchNameModal
          v-model="isResearchNameModalVisible"
          @created="createResearch"
        />
      </div>
    </Container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import API from '@/services/';
import { API_SUBMITTED_RESEARCH, API_RESEARCH } from '@/helpers/config';

import Navigation from '@/components/sidebars/Navigation.vue';
import Container from '@/components/core/Container.vue';
import Square from '@/components/core/Square.vue';
import ResearchNameModal from '@/containers/research/modules/ResearchNameModal.vue';


export default {
  components: {
    Navigation,
    Container,
    Square,
    ResearchNameModal,
  },
  data() {
    return {
      showLoader: true,
      researches: null,
      isResearchNameModalVisible: false,
    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
  },
  mounted() {
    this.getResearches();
  },
  methods: {
    getResearches() {
      const url = this.isAdmin ? API_SUBMITTED_RESEARCH : API_RESEARCH;

      API.get(url).then((response) => {
        this.researches = response.data.data;
        this.showLoader = false;
      }).catch((err) => {
        this.showLoader = false;
        this.$snotify.error(err);
      });
    },
    createResearch(researchName) {
      if (researchName !== '') {
        this.$ls.set('researchName', researchName, 60 * 60 * 6000);
        this.$router.push('/research/brief');
      } else {
        this.$snotify.warning('Please enter a project name');
      }
    },
    getSquareClass(index, length) {
      if (index + 1 < 3) return 'rounded-bottom-2';
      if (length > 5 && index + 1 < length - (length % 3)) return 'rounded-2';
      return 'rounded-top-2';
    },
  },
};
</script>

<style scoped>
.create-icon {
  width: 48px;
}
</style>
